import type { FunctionComponent } from 'react';
import styled from 'styled-components';
import { Inline, paletteHelper, Text } from '@property.com.au/ui-kit';
import { IconName } from '../types';
import { PropertyFeatureIcon } from './PropertyFeatureIcon';

export interface PropertyFeature {
  iconName: IconName;
  title: string;
  valueWithUnit?: string | null;
  hoverTitle?: string | null;
}

export const PropertyFeatureContainer = styled(Inline)`
  color: ${paletteHelper('textSecondary')};
`;

export const ValueWithUnit = styled(Text).attrs(() => ({
  variant: 'body02',
}))``;

export const PropertyFeature: FunctionComponent<PropertyFeature> = ({
  iconName,
  title,
  valueWithUnit,
  hoverTitle,
}) => {
  return (
    <PropertyFeatureContainer grow={false} gap="twoExtraSmall" title={title}>
      <PropertyFeatureIcon iconName={iconName} title={title} />
      {valueWithUnit && (
        <ValueWithUnit title={hoverTitle ?? undefined}>{valueWithUnit}</ValueWithUnit>
      )}
    </PropertyFeatureContainer>
  );
};
